import type { ReactNode } from 'react'
import { Label } from '~/components/ui/label'

/** Classes d'un champ natif (select, textarea) alignées sur `Input`. */
export const FIELD_CLASS = 'w-full rounded-md border border-input bg-transparent px-3 text-sm'

type IProps = {
  id: string
  label: string
  required?: boolean
  help?: string
  children: ReactNode
}

/** Un champ des formulaires qualité (#328) : son libellé, le contrôle, une aide éventuelle. */
function QualityField({ id, label, required, help, children }: IProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id} required={required}>{label}</Label>
      {children}
      {help && <p id={`${id}Help`} className="text-xs text-muted-foreground">{help}</p>}
    </div>
  )
}

export default QualityField
